import { useEffect, useMemo } from 'react'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'
import { Map, List } from 'immutable'
import { connect as connectRedux } from 'react-redux'
import { getBoundActions } from '../../actions/index'
import { MODAL_TYPES } from '../Modal/index'
import { TYPE_NOTIFICATION_VIDEO_PROMOTION } from '../../services/dialog/index'
import { RESOLVER_TYPE_NOT_FOUND } from '../../services/resolver/types'
import {
  isAccountPage,
  isSharePage,
  isPortal,
  isCart,
  isCartAccessDenied,
  isPlans,
  isGift,
  isGo,
  isGetStarted,
  isFullPlayer,
} from '../../services/url/index'
import { isEntitled } from '../../services/subscription/index'

const MODAL_ACTIVATION_TIME = 2000

function NotificationsVideoPromotion (props) {
  const {
    notification,
    staticText,
    isTourActive,
    renderModal,
    dismissModal,
    view,
    auth,
    resolver,
    setNotificationsReceived,
  } = props

  const isUserEntitled = isEntitled(auth.get('subscriptions', List()))

  const shouldShowModal = useMemo(() => {
    const path = resolver.getIn(['data', 'path'])
    const query = resolver.getIn(['data', 'query'])
    /**
     * do not show announcement if user already seen it
     * or tour is active or interstitial is active
     * or incopmlete checkout
     */
    if (isTourActive || view || !isUserEntitled) {
      return false
    }
    /**
     * do not show announcemnt if the page is not found
     */
    if (resolver.getIn(['data', 'type']) === RESOLVER_TYPE_NOT_FOUND) {
      return false
    }
    /**
     * do not show announcemnt for the specific pages
     */
    if (
      isAccountPage(path)
      || isSharePage(path)
      || isPortal(path)
      || isCart(path)
      || isCartAccessDenied(path)
      || isPlans(path)
      || isGift(path)
      || isGo(path)
      || isGetStarted(path)
      || isFullPlayer(query)
    ) {
      return false
    }
    return true
  }, [
    resolver,
    isTourActive,
    view,
    isUserEntitled,
  ])

  const handleCloseClick = () => {
    handleModalDismiss()
    dismissModal(TYPE_NOTIFICATION_VIDEO_PROMOTION)
  }

  const handleModalDismiss = () => {
    setNotificationsReceived({ ids: [notification.get('id')] })
  }

  useEffect(() => {
    const timer = setTimeout(() => {
      if (shouldShowModal) {
        renderModal(TYPE_NOTIFICATION_VIDEO_PROMOTION, {
          type: MODAL_TYPES.ROYAL_VIDEO,
          onDismiss: handleModalDismiss,
          onCloseClick: handleCloseClick,
          staticText,
          notification,
        })
      }
    }, MODAL_ACTIVATION_TIME)
    return () => {
      clearTimeout(timer)
    }
  }, [shouldShowModal])

  return null
}

NotificationsVideoPromotion.propTypes = {
  notification: ImmutablePropTypes.map.isRequired,
  staticText: ImmutablePropTypes.map.isRequired,
  auth: ImmutablePropTypes.map.isRequired,
  isTourActive: PropTypes.bool,
  view: PropTypes.string,
  checkoutComplete: PropTypes.bool,
}

export default connectRedux(
  (state) => ({
    staticText: state.staticText.getIn(['data', 'notificationsVideoPromotion', 'data'], Map()),
    isTourActive: state.tour.get('isActive'),
    auth: state.auth,
    view: state.interstitial.get('view'),
    resolver: state.resolver,
  }),
  (dispatch) => {
    const actions = getBoundActions(dispatch)
    return {
      renderModal: actions.dialog.renderModal,
      dismissModal: actions.dialog.dismissModal,
      setNotificationsReceived: actions.notifications.setNotificationsReceived,
    }
  },
)(NotificationsVideoPromotion)
